import { render, staticRenderFns } from "./IdentityVerificationSectionNonFace.vue?vue&type=template&id=58b6ffd2&scoped=true&"
import script from "./IdentityVerificationSectionNonFace.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationSectionNonFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6ffd2",
  null
  
)

export default component.exports